import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "kt_invoiceDiscountOfferPanel",
  class: "bg-body",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "invoiceDiscountOfferPanel",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'400px', 'lg': '400px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_invoiceDiscountOfferPanel_toggle",
  "data-kt-drawer-close": "#kt_invoiceDiscountOfferPanel_close"
}
const _hoisted_2 = { class: "card shadow-none w-100" }
const _hoisted_3 = {
  class: "card-header",
  id: "invoiceDiscountOfferPanel_header"
}
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-active-light-primary me-n5",
  id: "kt_invoiceDiscountOfferPanel_close"
}
const _hoisted_6 = { class: "svg-icon svg-icon-1" }
const _hoisted_7 = {
  class: "card-body pt-2",
  id: "invoiceDiscountOfferPanel_body"
}
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "mb-3 fw-bold fs-6 text-gray-800" }
const _hoisted_12 = { class: "mb-3 fw-bold fs-6 text-gray-800" }
const _hoisted_13 = { class: "mb-3 fw-bold fs-6 text-gray-800" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "mb-3 fw-bold fs-6 text-gray-800 d-flex align-items-center flex-wrap" }
const _hoisted_16 = { class: "mb-3 fw-bold fs-6 text-gray-800" }
const _hoisted_17 = { class: "mb-3 fw-bold fs-6 text-gray-800" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-stack text-start p-6 mb-5" }
const _hoisted_20 = { class: "d-flex align-items-center me-2" }
const _hoisted_21 = { class: "form-check form-check-custom form-check-solid form-check-primary me-6" }
const _hoisted_22 = ["id", "onChange", "value"]
const _hoisted_23 = { class: "flex-grow-1" }
const _hoisted_24 = { class: "d-flex align-items-center fs-3 fw-bold flex-wrap" }
const _hoisted_25 = { class: "fw-semibold opacity-50" }
const _hoisted_26 = { class: "ms-5" }
const _hoisted_27 = { class: "fs-2x fw-bold" }
const _hoisted_28 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("h3", { class: "card-title fw-bold text-dark" }, "QP Rules", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.isAddOfferFromIndex)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "fw-semibold fs-7 text-gray-600 mb-1" }, "Issue Date:", -1)),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formatDate((_ctx.invoice.IssueDate))), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "fw-semibold fs-7 text-gray-600 mb-1" }, "Sub Total:", -1)),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.currencyFormat(_ctx.invoice?.SubTotal, _ctx.invoice?.Currency)), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "fw-semibold fs-7 text-gray-600 mb-1" }, "Total Amount:", -1)),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.currencyFormat(_ctx.invoice?.TotalAmount, _ctx.invoice?.Currency)), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "fw-semibold fs-7 text-gray-600 mb-1" }, "Due Date:", -1)),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.formatDate(_ctx.invoice.DueDate)), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("div", { class: "fw-semibold fs-7 text-gray-600" }, "Issued By:", -1)),
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.vendor?.Name), 1),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "fw-semibold fs-7 text-gray-600" }, "Tax Amount:", -1)),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.currencyFormat(_ctx.invoice?.TaxAmount, _ctx.invoice?.Currency)), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.qpRules.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qpRules, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.Id,
                  class: "mt-3"
                }, [
                  _createElementVNode("label", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("input", {
                          id: "checkbox" + item.Id,
                          onChange: ($event: any) => (_ctx.handleQPChange($event, item.Id)),
                          class: "form-check-input qpCheckbox",
                          type: "checkbox",
                          value: item.Id
                        }, null, 40, _hoisted_22)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("h2", _hoisted_24, _toDisplayString(_ctx.countDate(item.Days)), 1),
                        _createElementVNode("div", _hoisted_25, _toDisplayString(item.Days) + " Days ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(item.Discount.toTwoFractionDigits()), 1),
                      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "fs-7 opacity-50" }, [
                        _createTextVNode(" / "),
                        _createElementVNode("span", { "data-kt-element": "period" }, "%")
                      ], -1))
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.isAddOfferFromIndex)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    id: "save_and_send_offer",
                    disabled: "",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.saveAndSendOffer && _ctx.saveAndSendOffer(...args))),
                    class: "btn btn-warning"
                  }, " Save and send "))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                id: "save_offer",
                disabled: "",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitOffer && _ctx.submitOffer(...args))),
                class: "btn btn-primary float-end"
              }, "Save")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_28, [...(_cache[10] || (_cache[10] = [
              _createElementVNode("div", {
                class: "card card-flush bgi-no-repeat bgi-size-contain bgi-position-x-end mt-5 h-md-50 mb-5 mb-xl-10",
                style: {"background-color":"#F1416C","background-image":"url('/media/patterns/vector-1.png')"}
              }, [
                _createElementVNode("div", { class: "card-body d-flex align-items-end" }, [
                  _createElementVNode("div", { class: "d-flex align-items-center flex-column mt-3 w-100" }, [
                    _createElementVNode("div", { class: "d-flex justify-content-center fw-bold fs-6 text-white opacity-75 w-100 mt-auto mb-2" }, [
                      _createElementVNode("span", null, "This Vendor does not have QP rules")
                    ])
                  ])
                ])
              ], -1)
            ]))]))
      ])
    ])
  ]))
}